import { CircularProgress } from "@suraasa/placebo-ui"
import { useEffect } from "react"
import { trackingService } from "utils/tracking"

import { AuthManager } from "../AuthManager"

export const Logout = () => {
  useEffect(() => {
    AuthManager.redirectToLogout()
    trackingService.reset()
  }, [])

  return (
    <div className="grid h-screen w-screen place-items-center">
      <CircularProgress size="lg" />
    </div>
  )
}
